module.exports = __webpack_public_path__ + "img/sprite.c0b4e580.png";